<template>
<div id="app">
  <div class="head-edit-wrap" _v-e84e105e>
    <Header-el></Header-el>
    <div
      class="modal-mask verify-content-modal modal-transition"
      _v-1f079041
      style="display: none;"
    >
      <div class="modal-wrapper" _v-1f079041>
        <div class="modal-container" _v-1f079041 style="width: 780px; height: auto;">
          <div class="modal-header" _v-1f079041>
            <h3 slot="header">
              <p class="title">实名认证</p>
              <p></p>
            </h3>
          </div>
          <div class="modal-body modal-body-zero" _v-1f079041>
            <div slot="body">
              <div class="content">
                <ul class="why-verify">
                  <li>
                    <div class="icon-box">
                      <span class="icon-kaistart-lock"></span>
                    </div>
                    <div>
                      <p class="why-title">安全</p>
                      <p class="why-digest">防止信息盗用，保护资产安全</p>
                    </div>
                  </li>
                  <li>
                    <div class="icon-box">
                      <span class="icon-kaistart-badge"></span>
                    </div>
                    <div>
                      <p class="why-title">方便</p>
                      <p class="why-digest">只需认证一次，支付畅通无阻</p>
                    </div>
                  </li>
                  <li>
                    <div class="icon-box">
                      <span class="icon-kaistart-heart-add"></span>
                    </div>
                    <div>
                      <p class="why-title">提升</p>
                      <p class="why-digest">客服时刻待命，服务更加贴心</p>
                    </div>
                  </li>
                  <li>
                    <div class="icon-box">
                      <span class="icon-kaistart-safe"></span>
                    </div>
                    <div>
                      <p class="why-title">监管</p>
                      <p class="why-digest">响应央行监管，保障您的权益</p>
                    </div>
                  </li>
                </ul>
                <section>
                  <div class="input-box">
                    <div _v-2b0c8a89>
                      <div class="input-box-inner" _v-2b0c8a89>
                        <span class="input-name" _v-2b0c8a89>
                          <span class="color-red">*</span>真实姓名
                        </span>
                        <input type="text" class="input-text" _v-2b0c8a89 placeholder="请填写真实姓名">
                      </div>
                    </div>
                  </div>
                  <div class="input-box">
                    <div _v-2b0c8a89>
                      <div class="input-box-inner" _v-2b0c8a89>
                        <span class="input-name" _v-2b0c8a89>
                          <span class="color-red">*</span>身份证号
                        </span>
                        <input type="text" class="input-text" _v-2b0c8a89 placeholder="请填写身份证号">
                      </div>
                    </div>
                  </div>
                  <div class="input-box">
                    <div _v-2b0c8a89>
                      <div class="input-box-inner" _v-2b0c8a89>
                        <span class="input-name" _v-2b0c8a89>
                          <span class="color-red">*</span>银行卡号
                        </span>
                        <input type="text" class="input-text" _v-2b0c8a89 placeholder="请填写银行卡号码">
                      </div>
                    </div>
                  </div>
                  <div class="input-box">
                    <div _v-2b0c8a89>
                      <div class="input-box-inner" _v-2b0c8a89>
                        <span class="input-name" _v-2b0c8a89>
                          <span class="color-red">*</span>手机号码
                        </span>
                        <input
                          type="text"
                          class="input-text"
                          _v-2b0c8a89
                          placeholder="请填写银行卡绑定的手机号码"
                        >
                      </div>
                    </div>
                  </div>
                </section>
                <p class="texttip">提示：请确保真实姓名、身份证号、银行卡开户人为同一人</p>
                <div class="blogTip">
                  <a href="/user/otherverify" target="_blank" title="非大陆用户进行实名认证">
                    <span class="question">?</span>
                    <span>非大陆用户实名认证</span>
                  </a>
                </div>
                <div class="showMsg" style="display: none;"></div>
                <section class="loading" style="display: none;">
                  <div class="spinner" _v-477f2a18>
                    <div class="spinner-container container1" _v-477f2a18>
                      <div class="circle1" _v-477f2a18></div>
                      <div class="circle2" _v-477f2a18></div>
                      <div class="circle3" _v-477f2a18></div>
                      <div class="circle4" _v-477f2a18></div>
                    </div>
                    <div class="spinner-container container2" _v-477f2a18>
                      <div class="circle1" _v-477f2a18></div>
                      <div class="circle2" _v-477f2a18></div>
                      <div class="circle3" _v-477f2a18></div>
                      <div class="circle4" _v-477f2a18></div>
                    </div>
                    <div class="spinner-container container3" _v-477f2a18>
                      <div class="circle1" _v-477f2a18></div>
                      <div class="circle2" _v-477f2a18></div>
                      <div class="circle3" _v-477f2a18></div>
                      <div class="circle4" _v-477f2a18></div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
          <div class="modal-footer" _v-1f079041>
            <div slot="footer">
              <div class="bt-box">
                <span>提交认证</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-mask tips-modal modal-transition" _v-1f079041 style="display: none;">
      <div class="modal-wrapper" _v-1f079041>
        <div class="modal-container" _v-1f079041 style="width: 420px; height: auto;">
          <div class="modal-header" _v-1f079041>
            <h3 slot="header">
              <p class="title">
                <span class="icon-kaistart-warn">
                  <span></span>
                </span>
              </p>
              <p></p>
              <p></p>
            </h3>
          </div>
          <div class="modal-body modal-body-zero" _v-1f079041>
            <div slot="body">
              <div class="content">根据央行最新监管规定，未通过实名认证无法进行支付。您确定不进行实名认证吗？</div>
            </div>
          </div>
          <div class="modal-footer" _v-1f079041>
            <div slot="footer">
              <div class="bt-box">
                <span>去认证</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="user">
    <div class="user-left">
      <div
        class="img"
        style="background-image:url('http://images.kaishiba.com/1460023021000612.jpg')"
      ></div>
      <p class="mt80p">造一座房子，住在水墨画里</p>
      <div class="tc mt30p">
        <i class="icon-kaistart-arrows-right"></i>
      </div>
      <div class="tc mt40">
        <a class="color-black" href="javascript:;">马上登录</a>
      </div>
    </div>
    <div class="user-right">
      <form action="user/reg" method="post" novalidate>
        <div class="mt60">
          <div class="ksui-form">
            <label>
              <span class="fs14 lh40 w100 tr mr20">
                <i class="color-red">*</i>昵称
              </span>
              <input
                class="fs14 invalid untouched pristine"
                placeholder="请输入昵称"
                type="text"
                name="nick"
              >
            </label>
            <div style="display: none;">
              <p class="fs12 lh20 ml145 color-red"></p>
            </div>
            <div style="display: none;">
              <p class="fs12 lh20 ml145 color-red">昵称不能为空</p>
            </div>
          </div>
        </div>
        <div class="ksui-form mt10">
          <label>
            <span class="fs14 lh40 w100 tr mr20">
              <i class="color-red">*</i>手机号
            </span>
            <input
              class="fs14 input-withBtn invalid untouched pristine"
              placeholder="请输入手机号码"
              type="text"
              name="phone"
            >
            <a class="ksui-form-btn border-gray">中国大陆 +86</a>
          </label>
          <div style="display: none;">
            <p class="fs12 lh20 ml145 color-red"></p>
          </div>
          <div style="display: none;">
            <p class="fs12 lh20 ml145 color-red">手机格式异常</p>
          </div>
        </div>
        <div class="vux-toast">
          <div class="weui_mask_transparent" style="display: none;"></div>
          <div
            class="weui_toast vux-fade-transition weui_toast_text"
            style="width: 20em; display: none;"
          >
            <i class="weui_icon_toast" style="display: none;"></i>
            <p class="weui_toast_content"></p>
          </div>
        </div>
        <div class="ksui-form mt10 null">
          <label>
            <span class="fs14 lh40 w100 tr mr20">
              <i class="color-red">*</i>验证码
            </span>
            <input
              class="fs14 input-withBtn invalid untouched pristine"
              placeholder="请输入验证码"
              type="text"
              autocomplete="off"
              name="verifycode"
            >
          </label>
          <a class="ksui-form-btn">获取验证码</a>
          <a class="ksui-form-btn retry" style="display: none;">
            <span class="mobileNone">重发验证码(0s)</span>
            <span class="mobileText">0s</span>
          </a>
          <div style="display: none;">
            <p class="fs12 lh20 ml145 color-red"></p>
          </div>
          <div style="display: none;">
            <p class="fs12 lh20 ml145 color-red">请输入6位数字验证码</p>
          </div>
        </div>
        <p style="margin-left: 200px">您之后可以用验证码直接登录，也可以在个人中心设置登录密码</p>
        <div class="reg-law">
          <p>
            <i class="icon-kaistart-complete color-green"></i>
            <label>我已仔细阅读并同意</label>
            <a
              href="https://blog.kaishiba.com/app_agreement"
              target="_blank"
              class="color-green"
            >《服务协议》</a>、
            <a
              href="https://blog.kaistart.com/privacypolicy"
              target="_blank"
              class="color-green"
            >《法律声明及隐私权政策》</a>
          </p>
          <p class="reg-law-tip color-red" style="display: none;">*请仔细阅读并同意《服务协议》、《法律声明及隐私权政策》。</p>
        </div>
        <div class="user-btnbox">
          <a class="ksui-btn" href="/login">返回登录</a>
          <input class="ksui-btn-green" type="button" value="注册">
        </div>
      </form>
    </div>
  </div>
  <div class="modal-mask modal-transition" _v-1f079041 style="display: none;">
    <div class="modal-wrapper" _v-1f079041>
      <div
        class="modal-container modal-container-padding"
        _v-1f079041
        style="width: 400px; height: auto;"
      >
        <div
          class="modal-close"
          _v-1f079041
          style="width: 30px; height: 30px; top: -15px; right: -15px; line-height: 30px;"
        >X</div>
        <div class="modal-header" _v-1f079041>
          <p slot="header" class="fs16">注册成功！</p>
        </div>
        <div class="modal-body" _v-1f079041>
          <p slot="body">
            3秒后自动跳转
            <a
              class="color-green"
              style="display:none"
              href="https://member.kaishiba.com/login.html"
            >登录页面</a>...
          </p>
        </div>
        <div class="modal-footer" _v-1f079041>
          <button
            class="modal-default-button modal-default-sure"
            _v-1f079041
            style="width: 150px; display: none;"
          >取消</button>
          <button
            class="modal-default-button modal-default-cancle"
            _v-1f079041
            style="width: 150px; display: none;"
          >取消</button>
        </div>
      </div>
    </div>
  </div>
  <Footer-el></Footer-el>
</div>
</template>
<style scoped>
@import url('../css/reg.css');
</style>


<script>
import header from '../components/header'
import footer from '../components/footer'
export default {
    name:"",
    components:{
        'Header-el':header,
        'Footer-el':footer
    }
}
</script>

